import React, { useState } from 'react';
import './Styles.css';
import { InputField, InputFieldAddon, InputFieldWrapper, InputSize } from '@ids/react-input-field';
import { Ui24Search } from '@ids/react-icons';
import { useAgentSearch } from './Functions';
import { formatMessage } from '../../../Localization/formatMessage';
import Messages from '../../../Localization/Messages';
import LoaderComponent from '../../../Elements/ids/Loader';

const SplitSalesSearch = ({ editedSplitData, setEditedSplitData }) => {
  const [state, setState] = useState({
    query: editedSplitData.coAgentCode || null,
    isLoading: false,
  });

  const agentList = useAgentSearch(
    state.query,
    isLoading => {
      setState({ ...state, isLoading });
    },
    editedSplitData.coAgentCode
  );

  return (
    <div>
      <div className="splitSales-searchBox">
        <label className="if splitSales-label">{formatMessage(Messages.splitSales_searchBoxLabel) + '*'}</label>
        <InputFieldWrapper>
          <InputFieldAddon>
            <Ui24Search aria-hidden />
          </InputFieldAddon>
          <InputField
            inputSize={InputSize.MEDIUM}
            onChange={e => {
              setState({ ...state, query: e.target.value });
              if (e.target.value.trim().length === 0) {
                setEditedSplitData({ ...editedSplitData, coAgentCode: null });
              }
            }}
            value={state.query ?? editedSplitData.coAgentCode ?? ''}
            autoComplete="off"
            placeholder={formatMessage(Messages.splitSales_searchBoxPlaceholder)}
          />
        </InputFieldWrapper>
      </div>

      <div>
        {state.isLoading ? (
          <LoaderComponent />
        ) : (
          <>
            {agentList.length > 0 && (
              <ul className="splitSales-searchResults">
                {agentList.map(agent => (
                  <li
                    key={agent.code}
                    className="splitSales-searchResults-row clickable"
                    onClick={() => {
                      setEditedSplitData({ ...editedSplitData, coAgentCode: agent.code });
                      setState({
                        ...state,
                        query: null,
                      });
                    }}>
                    {agent.code}
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SplitSalesSearch;
